import { useMemo } from 'react'
import { LinkProps, useLocation } from 'react-router-dom'
import { useGlobalState } from 'src/context/global'
import { useMediaContext } from 'src/context/responsive'
import { useSlider } from 'src/hooks'

export const useNavbarFunctions = () => {
  const { isMobileView } = useMediaContext()
  const location = useLocation()
  const [{ appConfig }] = useGlobalState()

  const {
    shouldShowAlreadyMember,
    shouldShowContactForm,
    shouldShowNumberOnMenu,
    shouldShowUnderConstruction,
    shouldShowEligibilityLink,
    template,
    providerPhone,
    formatPhone,
    eligibilityLinkUrl,
  } = appConfig

  const [style, clickToggle] = useSlider({
    sliderWidth: 320,
    enable: isMobileView,
  })

  const isSliderOpen = useMemo(() => {
    return style.transform === 'translateX(-320px)'
  }, [style.transform])

  const onClickLink = () => {
    if (isMobileView) {
      clickToggle()
    }
  }

  const contactLink: LinkProps['to'] = {
    pathname: '/contact',
    state: {
      from: location.pathname,
    },
  }

  const phoneNumber = providerPhone && providerPhone.replace(/[()-]/, '')
  const phoneText =
    providerPhone && formatPhone
      ? providerPhone.split('-').reduce<string>((acc, curr, i) => {
          if (i === 0) {
            return `(${curr})`
          }

          return i === 1 ? `${acc} ${curr}` : `${acc}-${curr}`
        }, '')
      : providerPhone

  const atLeastOneNavItem =
    shouldShowAlreadyMember || shouldShowContactForm || shouldShowNumberOnMenu

  return {
    onClickLink,
    clickToggle,

    isSliderOpen,
    style,
    isMobileView,
    contactLink,
    phoneNumber,
    phoneText,
    atLeastOneNavItem,
    template,
    eligibilityLinkUrl,

    shouldShowEligibilityLink,
    shouldShowUnderConstruction,
    shouldShowContactForm,
    shouldShowNumberOnMenu,
    shouldShowAlreadyMember,
  }
}
